export default {
  /** Nhỏ hơn */
  Less: -1,

  /** Bằng */
  Equal: 0,

  /** Lớn hơn */
  Than: 1,
};
